interface PopupWindowOptions {
  /** Width of the popup window */
  width?: number;
  /** Height of the popup window */
  height?: number;
  /** Whether to center the popup on the screen */
  centered?: boolean;
}

interface PopupParameters {
  location: number;
  width: number;
  height: number;
  left?: number;
  top?: number;
}

/**
 * Creates a popup window with the given parameters
 * @param options {@link PopupWindowOptions}
 * @returns The popup window
 */
function setupPopupWindow({
  width = 1000,
  height = 650,
  centered = true,
}: PopupWindowOptions = {}) {
  const parameters: PopupParameters = {
    location: 1,
    width,
    height,
  };

  if (centered) {
    parameters.left = (window.screen.width - width) / 2;
    parameters.top = (window.screen.height - height) / 2;
  }

  const features = Object.keys(parameters)
    .map((k) => `${k}=${parameters[k]}`)
    .join(',');

  const popup = window.open('', '', features);

  if (popup?.document) {
    popup.document.write('<html><head><title>Connecting...</title></head><body></body></html>');
  }

  return popup;
}

export type { PopupParameters };
export default setupPopupWindow;
